<div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Classificazione</h3>
  </div>
  <div class="container_dati_generali">
    <classificazione-form (classificazioniChange)="addClassificazione($event)" [hasPrincipale]="hasPrincipale"></classificazione-form>
    <table class="table-striped table aggiunta_classificazione">
      <caption class="sr-only">Tabella classificazione</caption>
      <tbody>
      <tr>
        <th>Materia</th>
        <th>Oggetto</th>
        <th>Argomento</th>
        <th>Primaria</th>
        <th></th>
      </tr>
      <tr *ngFor="let classificazione of classificazioni">
        <td>{{classificazione.materia?.label}}</td>
        <td>{{classificazione.oggetto?.label}}</td>
        <td>{{classificazione.argomento?.label}}</td>
        <td>{{classificazione.isPrincipale | booleanTransform}}</td>
        <td style="display: flex; justify-content: flex-end;">
            <button role="button" class="btn-link" aria-label="rimuovi classificazione" (click)="removeClassificazione(classificazione);">
              <span class="glyphicon glyphicon-trash"></span>
            </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
